import { IAddress } from "@/types";
import { streetDirections, streetTypes } from "../selectOptions";
import { get } from "lodash";

export function checkIfIsValidScrubbedAddress(
  scrubbedAddress: IAddress
): boolean {
  return !!(
    scrubbedAddress?.houseNumber &&
    scrubbedAddress?.streetName &&
    scrubbedAddress?.state &&
    scrubbedAddress?.city &&
    scrubbedAddress?.zipCode
  );
}
export function extractAddressDataFromGoogleAutoComplete(
  newAddress: Record<string, any>
): Record<string, any> {
  const {
    street_number = "",
    street_abbr = "",
    city = "",
    state = "",
    postal_code = "",
    street = ""
  } = newAddress;

  const splitStreet = street.split(" ");
  const streetTypeNewAddress = splitStreet[splitStreet.length - 1];
  const streetDirectionNewAddress = splitStreet[0];
  const findStreetType = streetTypes.find(
    (streetType: any) =>
      streetType.label.toLowerCase() === streetTypeNewAddress.toLowerCase()
  );
  const streetType = findStreetType ? findStreetType.value : "";

  const findStreetDirection = streetDirections.find(
    (streetDirection: any) =>
      streetDirection.label.toLowerCase() ===
      streetDirectionNewAddress.toLowerCase()
  );
  const streetDirection = findStreetDirection ? findStreetDirection.value : "";

  let streetName = "";
  if (findStreetType || findStreetDirection) {
    const getStreetName = splitStreet.filter(
      (name: string) =>
        name.toLowerCase() !== get(findStreetType, "label")?.toLowerCase() &&
        name.toLowerCase() !== get(findStreetDirection, "label")?.toLowerCase()
    );

    streetName = getStreetName.join(" ");
  }
  return {
    unitNumber: "",
    streetName: streetName ? streetName : street_abbr,
    houseNumber: street_number,
    streetDirection: streetDirection,
    streetType: streetType,
    city: city,
    state: state,
    zipCode: postal_code
  };
}
